import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

export function PremiumGate({
    title = "この機能は制限されています",
    description = "プランをアップグレードして、すべての機能を利用しましょう。",
    currentUsage,
    maxLimit,
    recommendedPlan = "standard"
}) {
    return (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-900/80 backdrop-blur-sm p-4 rounded-xl">
            <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-2xl text-center space-y-6">
                <div className="flex justify-center">
                    <div className="p-4 rounded-full bg-indigo-100 text-indigo-600 ring-4 ring-indigo-50">
                        <Lock className="w-8 h-8" />
                    </div>
                </div>

                <div className="space-y-2">
                    <h3 className="text-xl font-bold text-gray-900">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">
                        {description}
                    </p>
                </div>

                {(currentUsage !== undefined && maxLimit !== undefined) && (
                    <div className="bg-gray-50 rounded-lg p-3 text-sm border border-gray-100">
                        <p className="text-gray-600">
                            今週の利用回数: <span className="text-indigo-600 font-bold">{currentUsage}</span> / {maxLimit}
                        </p>
                    </div>
                )}

                <div className="pt-2">
                    <Link
                        to={`/subscription?plan=${recommendedPlan}`}
                        className="block w-full py-3 px-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold rounded-xl shadow-lg shadow-indigo-200 transition-all transform hover:-translate-y-0.5"
                    >
                        {recommendedPlan === 'business' ? 'Businessプランにアップグレード' : recommendedPlan === 'standard' ? 'Standardプランにアップグレード' : 'Studentプランにアップグレード'}
                    </Link>
                    <p className="mt-3 text-xs text-gray-400">
                        いつでもキャンセル可能です
                    </p>
                </div>
            </div>
        </div>
    );
}
